import React, { useEffect, useState } from 'react';
import { CheckCircle, XCircle } from 'lucide-react';
import { useParams } from 'react-router-dom';
import config from '../config';
import { useTranslation } from 'react-i18next';

const RedeemResult = () => {
  const { qrCode, userId } = useParams();
  const [status, setStatus] = useState('loading'); // loading | success | error
  const [message, setMessage] = useState('');
  const { t } = useTranslation();

  useEffect(() => {
    const redeem = async () => {
      try {
        const res = await fetch(config.getApiUrl(`offers/redeem/${qrCode}/${userId}`));
        const data = await res.json();

        if (data.success) {
            setStatus('success');
            setMessage(t('offer.redeemSuccess'));
        } else {
            setStatus('error');
            setMessage(t('offer.redeemAlreadyUsed'));
        }

      } catch (err) {
        setStatus('error');
        setMessage(t('offer.redeemError'));
      }
    };

    redeem();
  }, [qrCode, userId]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-6">
      <div className="bg-white shadow-lg rounded-lg p-6 max-w-md w-full text-center">
        {status === 'loading' && (
          <p className="text-gray-500">Checking redemption status...</p>
        )}

        {status === 'success' && (
          <div className="text-green-600">
            <CheckCircle className="w-16 h-16 mx-auto mb-3" />
            <h2 className="text-xl font-bold">Success</h2>
            <p className="mt-2">{message}</p>
          </div>
        )}

        {status === 'error' && (
          <div className="text-red-600">
            <XCircle className="w-16 h-16 mx-auto mb-3" />
            <h2 className="text-xl font-bold">Error</h2>
            <p className="mt-2">{message}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default RedeemResult;
